export const WhiteCircle = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M23.5 11.7667C23.5 17.9799 18.3606 23.0333 12 23.0333C5.63942 23.0333 0.5 17.9799 0.5 11.7667C0.5 5.55347 5.63942 0.5 12 0.5C18.3606 0.5 23.5 5.55347 23.5 11.7667Z"
      stroke="white"
    />
  </svg>
);

export const OrrangeCircle = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="12" cy="12" r="12" fill="#F2994A" />
    <path
      d="M17.8243 7.18613C17.59 6.93796 17.2101 6.93796 16.9757 7.18613L9.78737 14.7994L7.02428 11.873C6.78997 11.6248 6.4101 11.6248 6.17575 11.873C5.94142 12.1211 5.94142 12.5235 6.17575 12.7716L9.3631 16.1473C9.59734 16.3954 9.97749 16.3953 10.2116 16.1473L17.8243 8.0848C18.0586 7.83665 18.0586 7.43431 17.8243 7.18613Z"
      fill="white"
    />
  </svg>
);

export const CheckWhiteCircle = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <circle cx="8" cy="8" r="7.5" stroke="#FBFBFB" />
  </svg>
);

export const CheckOrangeCircle = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <circle cx="8" cy="8" r="8" fill="#F2994A" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.05028 10.6667C6.92762 10.6667 6.81028 10.616 6.72628 10.5267L4.56495 8.22489C4.39651 8.04622 4.40584 7.76489 4.58451 7.59689C4.76362 7.42889 5.04495 7.43778 5.21251 7.61644L7.04584 9.568L10.7827 5.47822C10.9489 5.29644 11.2298 5.28444 11.4112 5.44978C11.5921 5.61511 11.6045 5.89644 11.4392 6.07733L7.37828 10.5218C7.29517 10.6133 7.17695 10.6658 7.05339 10.6667H7.05028Z"
      fill="white"
    />
  </svg>
);

export const GreenCircle = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="12" cy="12" r="12" fill="#00A08B" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.5755 16C10.3915 16 10.2155 15.924 10.0895 15.79L6.84755 12.3374C6.59488 12.0694 6.60888 11.6474 6.87688 11.3954C7.14555 11.1434 7.56755 11.1567 7.81888 11.4247L10.5689 14.352L16.1742 8.21737C16.4235 7.9447 16.8449 7.9267 17.1169 8.1747C17.3882 8.4227 17.4069 8.8447 17.1589 9.11603L11.0675 15.7827C10.9429 15.92 10.7655 15.9987 10.5802 16H10.5755Z"
      fill="white"
    />
  </svg>
);

export const WhiteBigCircle = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="12" cy="12" r="11.5" stroke="#ADADAD" />
  </svg>
);
